import * as React from "react"
import { PropsWithChildren, ReactNode, useEffect, useState } from "react"
import { InteractionManager } from "react-native"

export interface LazyRenderProps extends PropsWithChildren<any>{
  timeout?: number,
  loading?: boolean,
  renderPlaceholder?: (props?) => ReactNode,
  placeholderProps?: PropsWithChildren<any>
}

/**
 * Describe your component here
 */
export const LazyRender = function LazyRender(props: LazyRenderProps) {
  const { timeout = 1, loading = false, renderPlaceholder, placeholderProps } = props
  const [ loaded, setLoaded ] = useState<boolean>(false)

  useEffect(() => {
    let mounted = true;
    const timeoutId = setTimeout(() => {
      InteractionManager.runAfterInteractions(() => {
        mounted && !loaded && !loading && setLoaded(true)
      })
    }, timeout)
    return () => {
      mounted = false;
      clearTimeout(timeoutId);
    }
  }, [loaded, loading, timeout])

  useEffect(() => {
    let mounted = true;
    const timeoutId = setTimeout(() => {
      mounted && setLoaded(true)
    }, timeout > 1000 ? timeout : 1000)

    return () => {
      mounted = false;
      clearTimeout(timeoutId)
    }
  }, [timeout])

  return <>{(loaded && !loading) && props.children || (renderPlaceholder && renderPlaceholder(placeholderProps)) || null}</>
}
